// ==================================
// Servicio de Configuracion de Plataforma
// ==================================

import api from './api';
import type { ApiResponse, ConfiguracionPlataforma } from '@/tipos';

export const configuracionServicio = {
  obtener: async (): Promise<ConfiguracionPlataforma> => {
    const response = await api.get<ApiResponse<ConfiguracionPlataforma>>(
      '/admin/configuracion'
    );
    return response.data.data;
  },

  actualizar: async (
    data: Partial<Pick<ConfiguracionPlataforma, 'precioKit' | 'mesesGratisConKit' | 'moneda'>>
  ): Promise<ConfiguracionPlataforma> => {
    const response = await api.patch<ApiResponse<ConfiguracionPlataforma>>(
      '/admin/configuracion',
      data
    );
    return response.data.data;
  },
};

export default configuracionServicio;
